<template>
  <div class="resource-info">
    <div class="resource-info-top">
        <div class="title">资源概况</div>
        <img class="title-bg" :src="require('@/assets/images/sydataboard/title-bg.png')" alt="">
    </div>
    <div class="resource-info-tab">
        <div class="name" @click="changeActive(true)" :class="isSelectResource ? 'is-active' : ''">资源分布</div>
        <div class="name" @click="changeActive(false)" :class="!isSelectResource ? 'is-active' : ''">题库建设</div>
    </div>
    <div class="resource-distribution" v-if="isSelectResource">
        <div v-if="isSelectResource" style="width:100%;height:100%;" :id="'resourceChartsId'"></div>
    </div>
    <div class="question-bank-build" v-if="!isSelectResource">
        <div class="number-statistics">
            <div class="number-item">
                <div class="name">题目数</div>
                <div class="number">8564</div>
            </div>
            <div class="number-item">
                <div class="name">学科数</div>
                <div class="number">12</div>
            </div>
        </div>
        <div class="school-list">
            <div class="school-item" v-for="(item,index) in schoolList" :key="item.schoolId">
                <div class="left">
                    <span>{{ index + 1 }}</span>{{ item.schoolName }}
                </div>
                <div class="right">
                    使用量：{{ item.useNumber }}
                </div>
            </div>
        </div>
    </div>
    <img class="top-left" :src="require('@/assets/images/sydataboard/top-left.png')" alt="">
    <img class="top-right" :src="require('@/assets/images/sydataboard/top-right.png')" alt="">
    <img class="left-bottom" :src="require('@/assets/images/sydataboard/left-bottom.png')" alt="">
    <img class="right-bottom" :src="require('@/assets/images/sydataboard/right-bottom.png')" alt="">
  </div>
</template>
<script>
import * as echarts from 'echarts';
export default {
  name: 'resource-info',
  data() {
    return {
        isSelectResource:true,
        resourceList:[
            {
                value:5500,
                name:'区域资源中心',
                number:55
            },
            {
                value:1000,
                name:'校本资源中心',
                number:10
            },
            {
                value:500,
                    name:'教师网盘',
                    number:5
            },
            {
                value:500,
                    name:'综合评审',
                    number:5
            },
            {
                value:500,
                    name:'在线课程',
                    number:5
            },
            {
                value:500,
                    name:'名师工作室',
                    number:5
            },
            {
                value:500,
                    name:'听评课',
                    number:5
            },
            {
                value:500,
                    name:'集体备课',
                    number:5
            },
            {
                value:500,
                    name:'特色活动',
                    number:5
            }
        ],
        schoolList:[
        {
              schoolName:"实验中学",
              useNumber:98,
              schoolId:1
            },
            {
              schoolName:"北京路中学",
              useNumber:97,
              schoolId:2
            },
            {
              schoolName:"赵家庄实验二中",
              useNumber:86,
              schoolId:3
            },
            {
              schoolName:"高新区实验中学",
              useNumber:86,
              schoolId:4
            },
            {
              schoolName:"华维文澜中学",
              useNumber:70,
              schoolId:5
            }
        ]
    }
  },
  methods: {
    /**
     * @name 切换tab
     */
    changeActive(value){
        if(value){
            this.isSelectResource = value;
            this.$nextTick(()=>{
                this.initEcharts(document.getElementById('resourceChartsId'),this.resourceList);
            })
        }else{
            echarts.init(document.getElementById('resourceChartsId')).dispose()
            this.isSelectResource = value;
        }
    },
    /**
     * @name 初始化echarts
     */
    initEcharts(dom,dataList){
        let myChart = echarts.init(dom)
        let option;
        option = {
            tooltip: {
                trigger: 'item',
                // show: false,
                // 数据的显示方式
                formatter: (param) => {
                    return `${param.data.name}  ${param.data.value}(${param.data.number}%)`
                }
            },
            legend: {
                selectedMode: false, // 是否允许点击
                type: 'scroll',
                pageIconColor:'#fff',
                orient: 'vertical',
                right: 0,
                top: 25,
                bottom: 0,
                padding:0, //图例内边距，单位px  5  [5, 10]  [5,10,5,10]
                itemGap: 18, //图例每项之间的间隔
                itemWidth: 9, //图例标记的图形宽度
                itemHeight: 9,
                formatter: (name) => {
                    const data = dataList.find((item)=>{
                        return item.name == name;
                    })
                    return `{name|${name}}{percent|${data.number || 0}%}{count|${data.value || 0}}`;
                },
                textStyle: {
                    rich: {
                        name: {
                            fontSize: 14,
                            verticalAlign: 'right',
                            align: 'left',
                            color:"#7ABFDB",
                            width: 90
                        },
                        percent: {
                            fontSize: 14,
                            align: 'left',
                            color:"#7ABFDB",
                            width: 60
                        },
                        count: {
                            fontSize: 14,
                            color:"#7ABFDB",
                            align: 'left'
                        }
                    },
                    color: '#909399',
                    borderWidth: 2
                },
            },
            series: [
                {
                    name: 'Access From',
                    type: 'pie',
                    radius: ['35%', '56%'],
                    center: ['20%', '50%'],
                    avoidLabelOverlap: false,
                    color: ['#2B7FFF','#27CDE6','#FDBA01','#FF7642','#F35D76','#A470EB','#646BF6','#43AAEC'],
                    label: {
                        show: false,
                        position: 'center',
                        formatter: (data) => {
                            return (
                            "{a|" +
                            data.data.number +
                            "%}" +
                            "\r\n" +
                            "{b|" +
                            data.data.name +
                            "}"
                            );
                        },
                        rich: {
                            a: {
                                fontSize: 16,
                                lineHeight: 20,
                                color: "#fff",
                                align: "center",
                                fontWeight: "bold",
                            },
                            b: {
                                fontSize: 12,
                                lineHeight: 16,
                                fontWeight: "bold",
                                color: "#7ABFDB",
                                align: "center",
                            },
                        },
                        backgroundColor: "transparent",
                        fontWeight: "bold",
                        fontSize: "15",
                        padding: 6,
                    },
                    emphasis: {
                        label: {
                        show: true,
                        fontWeight: 'bold'
                        }
                    },
                    labelLine: {
                        show: false
                    },
                    data: dataList
                }
            ]
        };
        option && myChart.setOption(option)
    },

  },
  watch: {

  },
  computed: {

  },
  mounted(){
    this.initEcharts(document.getElementById('resourceChartsId'),this.resourceList);
  }
}
</script>
<style lang="scss" scoped>
.resource-info{
    width: 100%;
    height: 330px;
    padding: 0 15px;
    border: 1px solid #053882;
    // background: rgba(6,17,52,0.8);
    // box-shadow: 0px 0px 10px 0px rgba(14,252,255,0.77);
    position: relative;
    margin-bottom: 20px;
    .resource-info-top{
        position: relative;
        text-align: center;
        margin-bottom: 15px;
        .title{
            display: inline-block;
            padding: 9px 22px 8px 17px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #D0E7FE;
            line-height: 20px;
            position: relative;
            z-index: 2;
        }
        .more{
            display: inline-block;
            position: absolute;
            top: 0px;
            right: 0px;
            height: 100%;
            line-height: 44px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #359AFF;
            cursor: pointer;
        }
        .title-bg{
            width: auto;
            height: 100%;
            position: absolute;
            top: 0;
            left: 50%;
            transform: translateX(-50%);
        }
    }
    .resource-info-tab{
        text-align: left;
        border-bottom: 1px solid rgba(112, 138, 204,0.2);
        .name{
            margin: 0 20px;
            padding-bottom: 10px;
            border-bottom: 2px solid transparent;
            font-size: 18px;
            font-family: Adobe Heiti Std;
            font-weight: normal;
            color: #BFD5ED;
            display: inline-block;
            cursor: pointer;
        }
        .is-active{
            color: #2773E6;
            border-color: #2773E6;
        }
    }
    .resource-distribution{
        width: 100%;
        height: calc(100% - 95px);
    }
    .question-bank-build{
        width: 100%;
        .number-statistics{
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 10px 0;
            .number-item{
                display: inline-flex;
                align-items: center;
                margin-right: 40px;
                .name{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #7ABFDB;
                }
                .number{
                    margin-left: 5px;
                    font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #FFFFFF;
                }
            }
            .number-item:last-child{
                margin-right: 0;
            }
        }
        .school-list{
            padding: 0 15px;
            .school-item{
                height: 28px;
                width: 100%;
                background: linear-gradient(90deg, rgba(16,48,109,0.99) 1%, rgba(114,190,255,0) 100%);
                border-radius: 2px;
                padding: 0 10px;
                margin-bottom: 9px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .left{
                    font-size: 14px;
                    font-family: DingTalk JinBuTi;
                    font-weight: 400;
                    color: #6EA0D3;
                    span{
                        margin-right: 15px;
                    }
                }
                .right{
                    font-size: 14px;
                    font-family: DingTalk JinBuTi;
                    font-weight: 400;
                    color: #6EA0D3;
                }
            }
            
        }
    }
    .top-left{
        position: absolute;
        top: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .top-right{
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
    .left-bottom{
        position: absolute;
        bottom: 0;
        left: 0;
        width: 14px;
        height: 14px;
    }
    .right-bottom{
        position: absolute;
        bottom: 0;
        right: 0;
        width: 14px;
        height: 14px;
    }
}
</style>